import { useQuery as useRetailerIdvStatusQuery } from "@faire/web-api--source/api/retailer-idv-status/retailerToken/get-hooks";
import { IGetRetailerIdvStatusResponse } from "@faire/web-api--source/indigofair/data/IGetRetailerIdvStatusResponse";

import { useRetailer } from "../../retailer/useRetailer";

import IdvStatus = IGetRetailerIdvStatusResponse.IdvStatus;

export const useIdvStatusQuery = () => {
  const { retailer, retailerToken } = useRetailer();
  const identityConfirmed = retailer?.identity_confirmed;

  const { data, ...result } = useRetailerIdvStatusQuery(retailerToken ?? "", {
    enabled: !!retailerToken && !identityConfirmed,
    staleTime: STALE_TIME,
    gcTime: STALE_TIME,
    refetchOnMount: false,
    initialData: identityConfirmed
      ? IGetRetailerIdvStatusResponse.build({
          idv_status: IdvStatus.IDV_REQUEST_RESPONDED,
        })
      : undefined,
  });

  return {
    data:
      data ??
      IGetRetailerIdvStatusResponse.build({
        idv_status: IdvStatus.IDV_STATUS_UNKNOWN,
      }),
    ...result,
  };
};

const STALE_TIME = 1000 * 60 * 5;
